// extracted by mini-css-extract-plugin
export default {"wrapper":"loading_wrapper__EUA+9","dot1":"loading_dot1__yIHvT","scale":"loading_scale__uo7kn","dot2":"loading_dot2__OUD5u","dot3":"loading_dot3__qQEg+","dot4":"loading_dot4__sTdJW"};